export enum TableName {
  Club = 'club',
  Offer = 'offer',
  Profile = 'profile',
  Setting = 'setting',
  Sport = 'sport',
  Team = 'team',
  Fee = 'fee',
  User = 'user'
}
